module.exports = __webpack_public_path__ + "img/umara.65d5550e.png";